import Vue from 'vue'
import VueRouter from 'vue-router'

// Main Components
import Dashboard from './layout/Dashboard'

// Pages
import Login from './views/pages/Login'
import Error404 from './views/pages/Error404'

// Data Import
import ImportRecord from './views/import/ImportRecord'
import StudentImportPreview from './views/import/PreviewStudent'

import StudentImportIndex from './views/import/StudentIndex'
import StudentImport from './views/import/Student'
import StudentApplicationDocumentsImport from './views/import/StudentApplicationDocuments'
import StudentApplicationDocumentsImportPreview from './views/import/PreviewApplicationDocuments'
import GradeImport from './views/import/Grade'
import GradeImportPreview from './views/import/PreviewGrade'

import GraduationImport from './views/import/Graduation'
import GraduationImportPreview from './views/import/PreviewGraduation'

import StatusImport from './views/import/Status'
import StatusImportPreview from './views/import/PreviewStatus'

// User Management
import UserIndex from './views/setting/user/Index'
import UserEdit from './views/setting/user/Edit'
import UserCreate from './views/setting/user/Create'

// change password
import ChangePassword from './views/setting/ChangePassword'



// Partners
import PartnerIndex from './views/setting/partner/Index'
import PartnerEdit from './views/setting/partner/Edit'
import PartnerCreate from './views/setting/partner/Create'

// Tuition Fee
import TuitionFee from './views/setting/tuitionfee/Index.vue'
import TuitionFeeCreate from './views/setting/tuitionfee/Create.vue'

// Campuses
import CampusIndex from './views/setting/partner/CampusIndex'
import CampusEdit from './views/setting/partner/CampusEdit'
import CampusCreate from './views/setting/partner/CampusCreate'

// Audits
import Audits from './views/setting/AuditIndex';

//login list
import LoginList from './views/setting/LoginList'

// Locked Records
import LockedRecord from './views/setting/LockedRecord';

// Ip
import IpIndex from './views/setting/IpIndex';

// ApiTokens
import ApiTokens from './views/setting/ApiTokens';

// GradeSettings
import GradingScale from './views/setting/GradingScale';

// Grading Scale
import GradingScaleIndex from './views/setting/gradingscale/Index'
import GradingScaleCreate from './views/setting/gradingscale/Create'
import GradingScaleEdit from './views/setting/gradingscale/Edit'

import GradingScaleTypes from './views/setting/GradingScaleTypes'

// Google 2FA
import Google2FA from './views/setting/Google2FA';

// Role
import RoleIndex from './views/setting/role/Index'
import RoleEdit from './views/setting/role/Edit'

import Department from './views/setting/Department'
import Position from './views/setting/Position'
import HrStatus from './views/setting/HrStatus'
import Status from './views/setting/Status'
import ProgramCodeType from './views/setting/ProgramCodeType'
import SpecializationMajor from './views/setting/SpecializationMajor'
import ProgramTranscriptTitle from './views/setting/ProgramTranscriptTitle'
import ReductionType from './views/setting/ReductionType'

// Student
import StudentCreate from './views/student/Create'
import StudentEdit from './views/student/Edit'
import StudentIndex from './views/student/Index'

import ContactView from './views/contact/Index'
import ContactShow from './views/contact/Show'

import TranscriptIndex from './views/transcript/Index'
import TranscriptFull from './views/transcript/Full'
import TranscriptTerm from './views/transcript/Term'
import TranscriptYear from './views/transcript/Year'

import StudentEnrollmentCreate from './views/student/CreateEnrollment'

// Alumni
import AlumniEdit from './views/alumni/Edit'
import AlumniIndex from './views/alumni/Index'

// Employee
import ProfessorIndex from './views/employee/professor/Index'
import ProfessorCreate from './views/employee/professor/Create'
import ProfessorEdit from './views/employee/professor/Edit'

// Staff
import StaffIndex from './views/employee/staff/Index'
import StaffCreate from './views/employee/staff/Create'
import StaffEdit from './views/employee/staff/Edit'

// Absence
import AbsenceIndex from './views/employee/AbsenceIndex'
import AbsenceCreate from './views/employee/AbsenceCreate'

// Reason
import ReasonIndex from './views/employee/ReasonIndex'

// Local Holidays
import HolidayIndex from './views/employee/HolidayIndex'

// Program
import ProgramIndex from './views/program/Index'
import ProgramCreate from './views/program/Create'
import ProgramEdit from './views/program/Edit'

// Company
import CompanyIndex from './views/company/Index'
import CompanyCreate from './views/company/Create'
import CompanyEdit from './views/company/Edit'

// Course
import CourseIndex from './views/course/Index'
import CourseCreate from './views/course/Create'
import CourseEdit from './views/course/Edit'

// Book
import BookIndex from './views/book/Index'
import BookCreate from './views/book/Create'
import BookEdit from './views/book/Edit'
import BookSubmission from './views/book/Submission'
import BookSubmissionEdit from './views/book/SubmissionEdit'
import BookSubmittedShow from './views/book/SubmittedShow'
import viewEditSubmissions from './views/book/Received'

// Book Bundle
import BookBundleIndex from './views/bookbundle/Index'
import BookBundleCreate from './views/bookbundle/Create'
import BookBundleEdit from './views/bookbundle/Edit'

// Invoices
import InvoiceIndex from './views/invoice/Index'
import InvoiceShowV1 from './views/invoice/v1/Show'
import InvoiceShowV2 from './views/invoice/v2/Show'

import BatchInvoiceCreate from './views/invoice/student/BatchCreate'

//Student Invoice
import StudentInvoiceIndex from './views/invoice/student/Index'
import StudentInvoiceCreate from './views/invoice/student/Create'
import StudentInvoiceEdit from './views/invoice/student/Edit'
import StudentInvoicePaidIndex from './views/invoice/student/Paid'
import StudentInvoicePendingIndex from './views/invoice/student/Pending'
import StudentInvoiceUnpaidIndex from './views/invoice/student/Unpaid'
import StudentInvoiceEmailed from './views/invoice/student/Emailed'

//Company Invoice
import CompanyInvoiceIndex from './views/invoice/company/Index'
import CompanyInvoiceCreate from './views/invoice/company/Create'
import CompanyInvoiceEdit from './views/invoice/company/Edit'
import CompanyInvoicePaidIndex from './views/invoice/company/Paid'
import CompanyInvoiceUnpaidIndex from './views/invoice/company/Unpaid'

// Payment Summaries
import PaymentSummariesIndex from './views/paymentsummary/Index'
import PaymentSummariesPendingIndex from './views/paymentsummary/Pending'
import PaymentSummaryShow from './views/paymentsummary/Show'
import PaymentSummaryEdit from './views/paymentsummary/Edit'

// Notifications
import NotificationBatchCreate from './views/notifications/CreateBatch'
import NotificationIndex from './views/notifications/Index'
import NotificationEditor from './views/notifications/Editor'
import NotificationEditorEdit from './views/notifications/EditorEdit'
import NotificationEditorCreate from './views/notifications/templates/Create'


import Home from './views/dashboard/Home.vue';

// Global Components
import Loading from 'vue-loading-overlay';
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';

import Pagination from './components/Pagination';
import Breadcrumb from './components/Breadcrumb.vue';
import BackButton from './components/BackButton.vue';

Vue.component('Loading', Loading);
Vue.component('Pagination', Pagination);
Vue.component('v-select', vSelect);
Vue.component('DatePicker', DatePicker);
Vue.component('Breadcrumb', Breadcrumb);
Vue.component('BackButton', BackButton);

Vue.use(VueRouter);

const routes = [{
        path: '',
        component: Dashboard,
        redirect: '/dashboard',
        children: [
            // Dashboard
            {
                path: 'dashboard',
                name: 'Home',
                component: Home
            },
            // Settings - Roles
            {
                path: 'roles/list',
                name: 'RoleIndex',
                component: RoleIndex
            },
            {
                path: 'roles/edit/:id',
                name: 'RoleEdit',
                component: RoleEdit
            },

            // Settings - Users
            {
                path: 'users/create',
                name: 'UserCreate',
                component: UserCreate
            },
            {
                path: 'users/list',
                name: 'UserIndex',
                component: UserIndex
            },
            {
                path: 'users/edit/:id',
                name: 'UserEdit',
                component: UserEdit
            },
            // change password
            {
                path: 'user/change-password',
                name: 'ChangePassword',
                component: ChangePassword
            },

            // Settings - Partners
            {
                path: 'partners/create',
                name: 'PartnerCreate',
                component: PartnerCreate
            },
            {
                path: 'partners/list',
                name: 'PartnerIndex',
                component: PartnerIndex
            },
            {
                path: 'partners/edit/:id',
                name: 'PartnerEdit',
                component: PartnerEdit
            },

            // Settings - TuitionFee
            {
                path: 'tuition-fee-management',
                name: 'TuitionFee',
                component: TuitionFee
            },
            {
                path: 'tuition-fee-create',
                name: 'TuitionFeeCreate',
                component: TuitionFeeCreate
            },


            // Settings - Campuses
            {
                path: 'campuses/create',
                name: 'CampusCreate',
                component: CampusCreate
            },
            {
                path: 'campuses/list',
                name: 'CampusIndex',
                component: CampusIndex
            },
            {
                path: 'campuses/edit/:id',
                name: 'CampusEdit',
                component: CampusEdit
            },

            // Settings - Audits
            {
                path: 'audits',
                name: 'AuditIndex',
                component: Audits
            },
            {
                path: 'login-list',
                name: 'LoginList',
                component: LoginList
            },


            // Settings - Locked Records
            {
                path: 'locked-records',
                name: 'LockedRecord',
                component: LockedRecord
            },

            // Settings - Ip
            {
                path: 'ips',
                name: 'IpIndex',
                component: IpIndex
            },

            // Settings - ApiTokens
            {
                path: 'api-tokens',
                name: 'ApiTokens',
                component: ApiTokens
            },

            // Settings - Grade
            // {
            //     path: 'grades',
            //     name: 'GradingScale',
            //     component: GradingScale
            // },

            // Settings - Grading Scale Types
            {
                path: 'grading-scale-types',
                name: 'GradingScaleTypes',
                component: GradingScaleTypes
            },

            // Settings - Grading Scale
            {
                path: 'grading-scales',
                name: 'GradingScaleIndex',
                component: GradingScaleIndex
            },
            {
                path: 'grading-scales/create',
                name: 'GradingScaleCreate',
                component: GradingScaleCreate
            },
            {
                path: 'grading-scales/edit/:id',
                name: 'GradingScaleEdit',
                component: GradingScaleEdit
            },

            // Settings - G2FA
            {
                path: 'google-2fa',
                name: 'Google2FA',
                component: Google2FA
            },

            // Student
            {
                path: 'student/create',
                name: 'StudentCreate',
                component: StudentCreate
            },
            {
                path: 'student/edit/:id',
                name: 'StudentEdit',
                component: StudentEdit
            },
            {
                path: 'students',
                name: 'StudentIndex',
                component: StudentIndex
            },
            {
                path: 'student/contact/list',
                name: 'StudentContactView',
                component: ContactView
            },
            {
                path: 'student/contact/show/:id',
                name: 'StudentContactShow',
                component: ContactShow
            },
            {
                path: 'alumni/contact/list',
                name: 'AlumniContactView',
                component: ContactView
            },
            {
                path: 'alumni/contact/show/:id',
                name: 'AlumniContactShow',
                component: ContactShow
            },
            {
                path: 'student/transcript/list',
                name: 'StudentTranscriptIndex',
                component: TranscriptIndex
            },
            {
                path: 'student/transcript/full/:id',
                name: 'TranscriptFullStudent',
                component: TranscriptFull,
            },
            {
                path: 'student/transcript/term/:id',
                name: 'TranscriptTermStudent',
                component: TranscriptTerm,
            },
            {
                path: 'student/transcript/year/:id',
                name: 'TranscriptYearStudent',
                component: TranscriptYear,
            },
            {
                path: 'student/report',
                name: 'StudentEnrollmentCreate',
                component: StudentEnrollmentCreate
            },

            // Alumni
            {
                path: 'alumni/edit/:id',
                name: 'AlumniEdit',
                component: AlumniEdit
            },
            {
                path: 'alumni',
                name: 'AlumniIndex',
                component: AlumniIndex
            },
            {
                path: 'alumni/transcript/list',
                name: 'AlumniTranscriptIndex',
                component: TranscriptIndex
            },
            {
                path: 'alumni/transcript/full/:id',
                name: 'TranscriptFullAlumni',
                component: TranscriptFull,
            },
            {
                path: 'alumni/transcript/term/:id',
                name: 'TranscriptTermAlumni',
                component: TranscriptTerm,
            },
            {
                path: 'alumni/transcript/year/:id',
                name: 'TranscriptYearAlumni',
                component: TranscriptYear,
            },
            // Employee
            {
                path: 'professor/list',
                name: 'ProfessorIndex',
                component: ProfessorIndex
            },
            {
                path: 'professor/create',
                name: 'ProfessorCreate',
                component: ProfessorCreate
            },
            {
                path: 'professor/edit/:id',
                name: 'ProfessorEdit',
                component: ProfessorEdit
            },

            {
                path: 'staff/list',
                name: 'StaffIndex',
                component: StaffIndex
            },
            {
                path: 'staff/create',
                name: 'StaffCreate',
                component: StaffCreate
            },
            {
                path: 'staff/edit/:id',
                name: 'StaffEdit',
                component: StaffEdit
            },

            // absence
            {
                path: 'absences/list',
                name: 'AbsenceIndex',
                component: AbsenceIndex
            },
            {
                path: 'absences/new',
                name: 'AbsenceCreate',
                component: AbsenceCreate
            },

            // reason
            {
                path: 'reasons',
                name: 'ReasonIndex',
                component: ReasonIndex
            },

            // Holiday
            {
                path: 'local-holidays',
                name: 'HolidayIndex',
                component: HolidayIndex
            },

            // Department
            {
                path: 'departments',
                name: 'Department',
                component: Department
            },

            // Position
            {
                path: 'positions',
                name: 'Position',
                component: Position
            },

            // Hr Status
            {
                path: 'hr-statuses',
                name: 'HrStatus',
                component: HrStatus
            },

            // Status
            {
                path: 'status-management',
                name: 'Status',
                component: Status
            },

            // ProgramCodeType
            {
                path: 'program-codes-types',
                name: 'ProgramCodeType',
                component: ProgramCodeType
            },

            // SpecializationMajor
            {
                path: 'program-specialization-major',
                name: 'SpecializationMajor',
                component: SpecializationMajor
            },

            // Transcript Title
            {
                path: 'program-transcript-title',
                name: 'ProgramTranscriptTitle',
                component: ProgramTranscriptTitle
            },


            //ReductionType
            {
                path: 'reduction-type-management',
                name: 'ReductionType',
                component: ReductionType
            },


            // Program
            {
                path: 'program/list',
                name: 'ProgramIndex',
                component: ProgramIndex
            },
            {
                path: 'program/create',
                name: 'ProgramCreate',
                component: ProgramCreate
            },
            {
                path: 'program/edit/:id',
                name: 'ProgramEdit',
                component: ProgramEdit
            },

            {
                path: 'program/clone/:id',
                name: 'ProgramClone',
                component: ProgramEdit
            },
            // Company
            {
                path: 'company/list',
                name: 'CompanyIndex',
                component: CompanyIndex
            },
            {
                path: 'company/create',
                name: 'CompanyCreate',
                component: CompanyCreate
            },
            {
                path: 'company/edit/:id',
                name: 'CompanyEdit',
                component: CompanyEdit,
            },

            // Course
            {
                path: 'course/list',
                name: 'CourseIndex',
                component: CourseIndex
            },
            {
                path: 'course/create',
                name: 'CourseCreate',
                component: CourseCreate
            },
            {
                path: 'course/edit/:id',
                name: 'CourseEdit',
                component: CourseEdit
            },
            {
                path: 'course/clone/:id',
                name: 'CourseClone',
                component: CourseEdit
            },

            // Book
            {
                path: 'book/list',
                name: 'BookIndex',
                component: BookIndex,
            },
            {
                path: 'book/create',
                name: 'BookCreate',
                component: BookCreate
            },
            {
                path: 'book/edit/:id',
                name: 'BookEdit',
                component: BookEdit
            },
            {
                path: 'book/submission',
                name: 'BookSubmission',
                component: BookSubmission
            },
            {
                path: 'book/submission/edit/:id',
                name: 'BookSubmissionEdit',
                component: BookSubmissionEdit
            },
            {
                path: 'book/submitted/show/:id',
                name: 'BookSubmittedShow',
                component: BookSubmittedShow
            },
            {
                path: 'book/view-edit-submissions',
                name: 'viewEditSubmissions',
                component: viewEditSubmissions
            },

            // Book Bundle
            {
                path: 'book/bundle/list',
                name: 'BookBundleIndex',
                component: BookBundleIndex
            },
            {
                path: 'book/bundle/create',
                name: 'BookBundleCreate',
                component: BookBundleCreate
            },
            {
                path: 'book/bundle/edit/:id',
                name: 'BookBundleEdit',
                component: BookBundleEdit
            },

            // Invoices
            {
                path: 'invoice/list',
                name: 'InvoiceIndex',
                component: InvoiceIndex
            },
            {
                path: 'v1/invoice/:id',
                name: 'InvoiceShowV1',
                component: InvoiceShowV1
            },
            {
                path: 'v2/invoice/:id',
                name: 'InvoiceShowV2',
                component: InvoiceShowV2
            },
            {
                path: 'invoices/batch/create',
                name: 'BatchInvoiceCreate',
                component: BatchInvoiceCreate
            },

            // Student Invoices
            {
                path: 'student/invoices',
                name: 'StudentInvoiceIndex',
                component: StudentInvoiceIndex
            },
            {
                path: 'student/invoice/create',
                name: 'StudentInvoiceCreate',
                component: StudentInvoiceCreate
            },
            {
                path: 'student/invoice/:id',
                name: 'StudentInvoiceEdit',
                component: StudentInvoiceEdit
            },
            {
                path: 'student/paidinvoices',
                name: 'StudentInvoicePaidIndex',
                component: StudentInvoicePaidIndex
            },
            {
                path: 'student/pendinginvoices',
                name: 'StudentInvoicePendingIndex',
                component: StudentInvoicePendingIndex
            },
            {
                path: 'student/unpaidinvoices',
                name: 'StudentInvoiceUnpaidIndex',
                component: StudentInvoiceUnpaidIndex
            },
            {
                path: 'student/emailed/invoices',
                name: 'StudentInvoiceEmailed',
                component: StudentInvoiceEmailed
            },

            // Company Invoices
            {
                path: 'company/invoices',
                name: 'CompanyInvoiceIndex',
                component: CompanyInvoiceIndex
            },
            {
                path: 'company/invoice/create',
                name: 'CompanyInvoiceCreate',
                component: CompanyInvoiceCreate
            },
            {
                path: 'company/invoice/:id',
                name: 'CompanyInvoiceEdit',
                component: CompanyInvoiceEdit
            },
            {
                path: 'company/paidinvoices',
                name: 'CompanyInvoicePaidIndex',
                component: CompanyInvoicePaidIndex
            },

            {
                path: 'company/unpaidinvoices',
                name: 'CompanyInvoiceUnpaidIndex',
                component: CompanyInvoiceUnpaidIndex
            },

            // Payment Summaries
            {
                path: 'payment-summaries/list',
                name: 'PaymentSummariesIndex',
                component: PaymentSummariesIndex
            },
            {
                path: 'payment-summaries/pending-list',
                name: 'PaymentSummariesPendingIndex',
                component: PaymentSummariesPendingIndex
            },
            {
                path: 'payment-summary/:id',
                name: 'PaymentSummaryShow',
                component: PaymentSummaryShow
            },
            {
                path: 'payment-summary-edit/:id',
                name: 'PaymentSummaryEdit',
                component: PaymentSummaryEdit
            },

            // Data Import
            {
                path: 'import/records',
                name: 'ImportRecord',
                component: ImportRecord
            },
            {
                path: 'import/students',
                name: 'StudentImportIndex',
                component: StudentImportIndex
            },

            {
                path: 'import-student/preview',
                name: 'StudentImportPreview',
                component: StudentImportPreview
            },

            {
                path: 'student-import',
                name: 'StudentImport',
                component: StudentImport
            },

            // Student Application Documents Import
            {
                path: 'application-documents-import',
                name: 'StudentApplicationDocumentsImport',
                component: StudentApplicationDocumentsImport
            },

            {
                path: 'import-application-documents/preview',
                name: 'StudentApplicationDocumentsImportPreview',
                component: StudentApplicationDocumentsImportPreview
            },

            {
                path: 'grade-import',
                name: 'GradeImport',
                component: GradeImport
            },
            {
                path: 'grade-import/preview',
                name: 'GradeImportPreview',
                component: GradeImportPreview
            },
            {
                path: 'graduation-import',
                name: 'GraduationImport',
                component: GraduationImport
            },
            {
                path: 'graduation-import/preview',
                name: 'GraduationImportPreview',
                component: GraduationImportPreview
            },
            {
                path: 'status-import',
                name: 'StatusImport',
                component: StatusImport
            },
            {
                path: 'status-import/preview',
                name: 'StatusImportPreview',
                component: StatusImportPreview
            },

            // Notifications
            {
                path: 'notifications/create-batch',
                name: 'NotificationBatchCreate',
                component: NotificationBatchCreate
            },
            {
                path: 'notifications/list',
                name: 'NotificationIndex',
                component: NotificationIndex
            },
            {
                path: 'notifications/templates',
                name: 'NotificationEditor',
                component: NotificationEditor
            },
            {
                path: 'notifications/templates/create',
                name: 'NotificationEditorCreate',
                component: NotificationEditorCreate
            },
            {
                path: 'notifications/templates/:id',
                name: 'NotificationEditorEdit',
                component: NotificationEditorEdit
            },

        ]
    },
    {
        path: '/login',
        component: Login,
        name: 'login'
    },
    {
        path: '*',
        component: Error404,
        name: 'Error404'
    }
];

let router = new VueRouter({
    mode: 'history',
    linkExactActiveClass: 'active',
    routes,
});

router.afterEach((to, from) => {
    if (from.params.id) {
        clearLockedCache(from.params.id, from.name);
    }
})

router.beforeEach((to, from, next) => {
    if (from.params.id) {
        clearLockedCache(from.params.id, from.name);
        next();
    } else
        next();
})

export default router;
